module.exports = __webpack_public_path__ + "static/media/press22.3a8af616.png";